import React, {useEffect, useState} from "react";
import SafeImage from "../../layout/reusable/SafeImage";
import {getTeams} from "../../utils/cms.utils";

const Team = () => {
    const [teamData, setTeamData] = useState([]);

    useEffect(() => {
        const data = getTeams();
        setTeamData(Array.isArray(data) ? data : []);
    }, []);

    if (!teamData.length) return null;

    return (
        <section className="team__area section-padding">
            <div className="container">

                {/* ===== TITLE ===== */}
                <div className="row mb-35">
                    <div className="col-xl-12">
                        <div className="team__area-title t-center">
                            <span
                                className="subtitle wow fadeInLeft"
                                data-wow-delay=".4s"
                            >
                                Meet Our Experts
                            </span>

                            <h2 className="title_split_anim">
                                Company Organizational Structure
                            </h2>

                            <h5 className="title_split_anim">
                                Struktur Organisasi
                            </h5>
                        </div>
                    </div>
                </div>

                {/* ===== TEAM GRID ===== */}
                <div className="row">
                    {teamData.slice(0, 4).map((member) => (
                        <div
                            className="col-lg-3 col-md-6 mt-25"
                            key={member?.id}
                        >
                            <div className="team__card">

                                {/* IMAGE */}
                                <div className="team__card-image">
                                    <SafeImage
                                        src={member?.image}
                                        alt={member?.name}
                                        isCoverImage
                                    />
                                </div>

                                {/* CONTENT */}
                                <div className="team__card-content">
                                    <h5 className="team__name">
                                        {member?.name}
                                    </h5>

                                    {member?.positionEn && (
                                        <span className="team__position">
                                            {member?.positionEn}
                                        </span>
                                    )}

                                    {member?.positionId && (
                                        <span className="team__position-sub">
                                            {member?.positionId}
                                        </span>
                                    )}
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Team;
